import { useQuery } from 'react-query';
import NotificationsApi from '../../../../../api/public/NotificationsApi';

const useGetNotificationBellCount = () => {
    return useQuery('notificationBellCount', () => NotificationsApi.getNotificationCount());
};

export default useGetNotificationBellCount;
